import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import * as Actions from '../actions';
import ReactDOM from 'react-dom';
import Helpers from '../lib/helpers';
import Settings from '../lib/settings';

class Items extends Component {

  constructor(props) {
    super(props);
    this.state = {
      shopItems: [],
      allItems: [],
      showed: 0,
      totalShowedOnPage: 12,
      imagesize: 1,
      turnOffAlert: false
    };
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
    this.handleTurnOffAlert = this.handleTurnOffAlert.bind(this);
    this.handleImagesizeChange = this.handleImagesizeChange.bind(this);
  }

  getProducts(slugIn) {
    var slug = slugIn
      ? "/" + slugIn
      : "";

    if (slug === "") {
      window.scrollTo(0, 0);
    }

    //this.props.dispatch(Actions.loader(true));
    fetch('/api/products' + slug, Settings.fetchParams('GET')).then(res => {
      this.props.dispatch(Actions.loader(false));
      if (res.ok) {
        res.json().then(json => {
          if(json.length > 0) {
            if(!this.props.admin) {
              json = Helpers.shuffle(json);
            }
            this.setState({
              allItems: json,
              shopItems: json.slice(0, this.state.totalShowedOnPage),
              showed: this.state.totalShowedOnPage
            });
          } else {
            this.setState({
              allItems: [],
              shopItems: [],
              showed: this.state.totalShowedOnPage
            });
          }
        });
      }
    });

  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getProducts(this.props.match.params.slug);
  }

  componentWillReceiveProps(newProps) {

    this.getProducts(newProps.match.params.slug);

  }

  handleTurnOffAlert(event) {
    this.setState({
      turnOffAlert: event.target.checked
    });
  }

  deleteProduct(slug, i) {
    let canDelete = window.confirm("Opravdu chcete smazat produkt?");
    if (canDelete) {
      //this.props.dispatch(Actions.loader(true));
      fetch("/api/products/" + slug, Settings.fetchParams('DELETE')).then(res => {
        this.props.dispatch(Actions.loader(false));
        if (res.ok) {
          res.json().then(json => {
            if (!json.error && json.deleted) {

              let items = this.state.shopItems;
              items.splice(i, 1);
              this.setState({shopItems: items});

            } else {
              console.log("Error");
            }
          })
        } else {
          alert("Error");
        }
      });

    }
  }

  activateProduct(slug, i) {
    let items = this.state.shopItems;
    let canActivate;

    if(!this.state.turnOffAlert) {
      if (items[i].active) {
        canActivate = window.confirm("Opravdu chcete produkt deaktivovat?");
      } else {
        canActivate = window.confirm("Opravdu chcete produkt aktivovat?");
      }
    }

    if (canActivate || this.state.turnOffAlert) {
      //this.props.dispatch(Actions.loader(true));
      fetch("/api/products/activate/" + slug, Settings.fetchParams('POST')).then(res => {
        this.props.dispatch(Actions.loader(false));
        if (res.ok) {
          res.json().then(json => {
            if (!json.error) {

              let items = this.state.shopItems;
              items[i].active = json.active;
              this.setState({shopItems: items});

            } else {
              alert("Error");
            }
          })
        } else {
          alert("Error");
        }
      });

    }
  }

  onLoadMoreClick() {
    let from = this.state.showed;
    let to = from + this.state.totalShowedOnPage;
    this.setState({
      shopItems: this.state.shopItems.concat(this.state.allItems.slice(from,to)),
      showed: to
    })
  }

  handleImageLoaded(event) {
      event.target.classList.remove("imageLoading");
  }

  handleImagesizeChange(event, item, index) {
      let shopItems = this.state.shopItems;
      shopItems[index].size = event.target.value;
      this.setState({
        shopItems: shopItems
      })
      ReactDOM.findDOMNode(this.refs['imageSliderWrapper' + index]).style.opacity = 1;
  }

  sendSize(event, item, index) {
      fetch('/api/products/setsize/' + item.slug, Settings.fetchParams('POST', {size: event.target.value})).then(res => {
        //this.props.dispatch(Actions.loader(false));
        if (res.ok) {
          res.json().then(json => {
            if (!json.error) {
              console.log("ok");
            } else {
              alert("Chyba při nastavování velikosti.");
            }
          })
        } else {
          alert("Chyba 2 při nastavování velikosti.");
        }
      });
      ReactDOM.findDOMNode(this.refs['imageSliderWrapper' + index]).style.removeProperty('opacity');
  }

  render() {

    const Discount = (discount) => <div className="shopDiscount">-{discount}%</div>;
    const EditProductButtons = (item, index) => this.props.admin
      ? <div>
          <Link className="editProductButton" to={"/addproduct/" + item.slug}>
            <i className="fas fa-edit"></i>
          </Link>
          <div className="deleteProductButton" onClick={() => {
              this.deleteProduct(item.slug, index)
            }}>
            <i className="fas fa-trash-alt"></i>
          </div>
          <div className={item.active
              ? "deactivateProductButton"
              : "activateProductButton"} onClick={() => {
              this.activateProduct(item.slug, index)
            }}>
            <i className={item.active
                ? "fas fa-check"
                : "fas fa-times"}></i>
          </div>
        </div>
      : "";

    const Items = this.state.shopItems.map((item, index) => {

      let imageSize = {};
      let itemSize;

      if(typeof item.size !== "undefined") {
        imageSize = { maxWidth: item.size + "%", maxHeight: item.size + "%" };
        itemSize = item.size;
      } else {
        itemSize = 100;
      }
    return (<div key={index} className="shopItem">

      <Link to={"/product/" + item.slug} key={index}>

        <div className="shopItemImg">
          <img src={"/img/products/" + item.images[0].replace(/(\.[\w\d_-]+)$/i, '_thumb$1')} alt=""  className="imageLoading" onLoad={this.handleImageLoaded} style={imageSize} />
        </div>
        {
          typeof item.discount !== "undefined"
            ? Discount(item.discount)
            : ""

        }
        <div className="shopItemName">{item.name}</div>
        <div className="shopItemPrice">{
            typeof item.discount !== "undefined"
              ? <div>
                  <span className="st">{item.originalPrice}
                    Kč</span>
                  <span className="red">{item.price}
                    Kč</span>
                </div>
              : item.price + " Kč"
          }
        </div>

      </Link>
      {EditProductButtons(item, index)}
      {
      this.props.admin
          ?
      <div className="imageSliderWrapper" ref={"imageSliderWrapper" + index}>Velikost obrázku {itemSize}%<input type="range" min="1" max="100" className="slider" value={itemSize} onChange={(e) => this.handleImagesizeChange(e, item, index)} onMouseUp={(e) => this.sendSize(e, item, index)} /></div>
      :
      ""
      }
    </div>)});

    return (<div className="overflowHidden">
      <div className="shopItems">
        {
          this.props.admin
          ? <label className="turnOffAlert"><input type="checkbox" checked={this.state.turnOffAlert} onChange={this.handleTurnOffAlert}/>Vypnout dočasně potvrzení aktivace produktu</label>
          : ""
        }

        {Items}
      </div>{
        this.state.showed >= this.state.allItems.length ? "" :
        <div className="loadMoreItems" onClick={this.onLoadMoreClick.bind(this)}>
          <p><span className="pulsing">Načíst další produkty</span></p>
        </div>
      }

    </div>);
  }
}
function mapStateToProps(state) {
  return {admin: state.admin};
}
export default withRouter(connect(mapStateToProps)(Items));



// WEBPACK FOOTER //
// ./src/pages/Items.js